
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { TerraceFormValues } from "./types";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

interface TerraceContactProps {
  form: UseFormReturn<TerraceFormValues>;
  disabled?: boolean;
}

const TerraceContact: React.FC<TerraceContactProps> = ({ form, disabled = false }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <FormField
        control={form.control}
        name="website"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Website</FormLabel>
            <FormControl>
              <Input 
                placeholder="https://..." 
                {...field} 
                disabled={disabled}
                className={disabled ? "bg-muted text-muted-foreground" : ""}
              />
            </FormControl>
            <FormDescription>
              {disabled ? "Will be filled automatically" : "Optional"}
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="phone"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Phone</FormLabel>
            <FormControl>
              <Input 
                placeholder="+46 123 456 789" 
                {...field} 
                disabled={disabled}
                className={disabled ? "bg-muted text-muted-foreground" : ""}
              />
            </FormControl>
            <FormDescription>
              {disabled ? "Will be filled automatically" : "Optional"}
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default TerraceContact;
